/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import AnalyticsService from 'cio/services/analytics';
import { inject as service } from '@ember/service';
import { announceHydraNavigate } from '@customerio/hydra-nav-state';
import { FlyMouseEvent } from '@customerio/fly-components/types/events';
import EnvironmentService from 'cio/services/environment';

export default class SetupGuideSourcesDataPipelines extends Component {
  @service analytics!: AnalyticsService;
  @service environment!: EnvironmentService;

  get pipelinesSetupGuideUrl() {
    return `/workspaces/${this.environment.current.id}/pipelines/setup-guide`;
  }

  @action
  onGetStartedLinkClick(event: FlyMouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    announceHydraNavigate(this.pipelinesSetupGuideUrl, { targetApp: 'pipelines' });
  }
}
